import createReactComponent from '../createReactComponent';
export default createReactComponent('fine-tune', 'FineTune', [["path",{"d":"M10 8.5h11m-18 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0m0 7h11m3 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0","key":"svg-0"}]]);